import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { StoreContext } from 'redux-react-hook';
import { RecoilRoot } from 'recoil';
import styled from 'styled-components/macro';
import Layout from './components/Layout';
import './index.css';

// Firebase
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore/memory';

import FirebaseContext from './components/Firebase/context';
import store from './store';

const NotFound = styled.div`
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem;
`;

const config = {
  apiKey: 'AIzaSyCeWWiIn8HxaQS55mULzbeQm6Ckpp3V1Ro',
  authDomain: 'azurdockyard.firebaseapp.com',
  databaseURL: 'https://azurdockyard.firebaseio.com',
  projectId: 'azurdockyard',
  storageBucket: 'azurdockyard.appspot.com',
  messagingSenderId: '1082072498065',
};
const app = firebase.initializeApp(config);
// firebase.firestore.setLogLevel('debug');

const contextType = { firebase: app };

ReactDOM.render(
  <Provider store={store}>
    <StoreContext.Provider value={store}>
      <Router>
        <Switch>
          <FirebaseContext.Provider value={contextType}>
            <RecoilRoot>
              <Layout />
            </RecoilRoot>
          </FirebaseContext.Provider>

          <Route>
            <NotFound>Page Not Found</NotFound>
          </Route>
        </Switch>
      </Router>
    </StoreContext.Provider>
  </Provider>,
  document.getElementById('root'),
);
